import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import langData from '../../assets/langs/lang.json';
import { getInitialLanguage } from '../../assets/js/LanguageContext';
import '../../assets/styles/SurveyAnswer.css';

/* Si algo falla al dibujar una página, React la desmonta entera y deja la pantalla en blanco.
 * Esto lo captura y enseña un aviso con "Recargar" y "Volver al inicio".
 *
 * Es un componente de clase porque React solo permite capturar errores de render así. No usa el
 * contexto de idioma ni el router a propósito: tiene que funcionar aunque lo que falle sea eso mismo.
 * `resetKey` (la ruta actual) lo reinicia al navegar, para que un error en una página no bloquee las demás.
 */
const text = (key) => {
  const language = getInitialLanguage();
  return langData[language]?.[key] || langData.en?.[key] || key;
};

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Error al mostrar la página:', error, info?.componentStack);
  }

  componentDidUpdate(prevProps) {
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <main className="tp-answer" role="alert">
        <div className="tp-answer__inner tp-answer__inner--center">
          <section className="tp-answer__card tp-answer__state">
            <span className="tp-answer__state-icon" aria-hidden="true">
              <AlertTriangle size={28} strokeWidth={1.75} />
            </span>
            <h1 className="tp-answer__question">{text('error_page_title')}</h1>
            <p className="tp-answer__hint">{text('error_page_text')}</p>
            <div className="tp-state-actions">
              <button type="button" className="btn btn--primary" onClick={() => window.location.reload()}>
                <RefreshCw size={16} strokeWidth={2} aria-hidden="true" />
                {text('error_page_reload')}
              </button>
              {/* Enlace normal y no <Link>: si lo que ha fallado es el router, un <Link> tampoco funcionaría */}
              <a href="/" className="btn btn--outline">{text('notfound_home')}</a>
            </div>
          </section>
        </div>
      </main>
    );
  }
}

export default ErrorBoundary;
